import { PATHS } from '@ctcells/core'
import { t } from '@ctcells/i18n'
import { useNavigate } from 'react-router'

import { AddModal } from '../atoms/AddModal.tsx'
import { RecipeNewStandardContainer } from '../screens/recipes/RecipeStandardContainer.tsx'
import { RecipesContainer } from '../screens/recipes/RecipesContainer.tsx'

/**
 * 「준비」 무리의 **추가 창** — 목록 위에 뜨는 창이다(eric 2026-09-30 「작업에서 생성, 준비에서 시료 추가,
 * 레시피에서 레시피 추가, 랩웨어에서 랩웨어 추가 … 다 통일하고 … 팝업창이 뜨도록」).
 * 새 작업(`NewBatchModalRoute` · 2026-09-22)과 같은 뼈대다. 🔴 창은 추가 창 일곱이 **`AddModal` 하나**다(옵션 `ADD_MODAL` ·
 * eric 2026-09-30 「포맷을 모두 동일하게」) — 여기서 `Modal` 옵션을 따로 적지 마라.
 * ⚠ 랩웨어 추가 창은 2026-10-11 에 걷었다 — 옛 카탈로그를 서버가 걷었고 대체는 레시피 › 템플릿(`labware`)의 추가 창이다.
 *
 * - 주소는 종전 그대로(`/recipes/new`)라 **직접 링크 · 새로고침이 창을 그대로 되살린다**
 * - 닫으면(× · Esc · 바깥 누름 · 취소) 목록 주소로. 🔴 **보내는 중에는 안 닫힌다** — 폼이 `DetailPage busy` 로 창을 잠근다
 * - 만들면 컨테이너가 **만든 것의 서랍**(`/recipes/:id`)으로 간다 — 주소가 바뀌며 창이 닫히고
 *   서랍이 열린다. 목록은 커맨드의 쿼리 무효화로 새로 받는다
 * - 🔴 폼은 **페이지 컴포넌트 그대로**다(`RecipeNewScreen`). 창 안이면 `DetailPage` 가
 *   제목 줄 · 「← 목록」을 접고 버튼 줄을 창 바닥으로 옮긴다(`atoms/modalFrame.ts`). 폼을 두 벌 만들지 않는다
 * - 덮개는 본문 범위(`scope="body"`)다 — 머리줄과 상시 작업 줄(E-STOP)은 창이 떠 있어도 눌린다(07 §6)
 * - ⚠ 페이지로 되돌리려면 라우트 표의 그 줄을 `RecipeNewContainer` 로 바꾸면 끝이다
 *   (장비 관점 콘솔이 그렇게 쓴다)
 *
 * 라우트 표(`consoleResourceRoutes.tsx`)와 파일을 나눈 것은 한 파일이 컴포넌트만 내보내야 핫리로드가 성립해서다.
 */
export function RecipeNewModalRoute() {
  const navigate = useNavigate()
  return (
    <div className="splitpage splitpage--half">
      <RecipesContainer resourceTab="recipes" />
      {/*
        🔴 「＋ 레시피」는 서버 표준 레시피를 불러온 채로 시작한다(eric 2026-10-12 「바로 표준 레시피로 시작.. 빈 레시피 처럼 나오되..
           표준 레시피의 값들이 임포트 한 상태」) — 옛 형식 편집기(`RecipeNewContainer` · 값 직접 설정 · 복제 · JSON)는 콘솔 창에서 걷었다
           (서버의 레시피 형식이 새 형식 하나다 · `recipe_v2/__init__.py`). 장비 관점 콘솔의 페이지 라우트는 그대로다
      */}
      <AddModal
        size="lg"
        onClose={() => void navigate(PATHS.recipes)}
        title={t('screen.recipeNew.title')}
      >
        <RecipeNewStandardContainer />
      </AddModal>
    </div>
  )
}

/** 「＋ 레시피 추가 › 표준 레시피에서」(2026-10-06) — 빈 레시피 창과 같은 자리 · 같은 틀 */
export function RecipeNewStandardModalRoute() {
  const navigate = useNavigate()
  return (
    <div className="splitpage splitpage--half">
      <RecipesContainer resourceTab="recipes" />
      {/* 옛 주소(템플릿 판 「이 템플릿으로 레시피 만들기」 · 직접 링크)도 같은 창이다 */}
      <AddModal
        size="lg"
        onClose={() => void navigate(PATHS.recipes)}
        title={t('screen.recipeNew.title')}
      >
        <RecipeNewStandardContainer />
      </AddModal>
    </div>
  )
}
